/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Card_UpvoteInputs */

const en_directory_card_upvote = /** @type {(inputs: Directory_Card_UpvoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upvote product`)
};

const zh_directory_card_upvote = /** @type {(inputs: Directory_Card_UpvoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点赞产品`)
};

/**
* | output |
* | --- |
* | "Upvote product" |
*
* @param {Directory_Card_UpvoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_card_upvote = /** @type {((inputs?: Directory_Card_UpvoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Card_UpvoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_card_upvote(inputs)
	return zh_directory_card_upvote(inputs)
});
export { directory_card_upvote as "directory.card.upvote" }